export const EMAIL_PATTERN =
  '^(([^<>()[\\]\\.,;:\\s@"]+(\\.[^<>()[\\]\\.,;:\\s@"]+)*)|.(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$';
export const PHONE_PATTERN = '^\\d{7}$';
export const USERNAME_PATTERN = '^[a-zA-Z0-9]{5,10}$';
export const AMOUNT_PATTERN = /^\d+(\.\d{1,2})?$/;
export const AMOUNT_WITHOUT_DECIMAL_PATTERN = /^\d+$/;
export const AMOUNT_TRAILING_DECIMAL_PATTERN = /^\d+\./;
export const COMMA_PATTERN = /,/g;
export const DECIMAL_DOT_PATTERN = /\./g;
export const ANNUAL_DEPOSIT_PATTERN =
  /^(?:\d{1,7}|(?:[1-9]\d{0,2}(?:,\d{3}){0,2}|1[0-4]\d{6}|15000000))(?:\.\d{1,2})?$/;
export const DATE_VALUE_FORMAT = 'yyyy-MM-dd';
export const TIN_PATTERN = '^\\d[0-9]+$';
export const FOREIGN_TAX_NUMBER_OTHER_PATTERN = '^[A-Za-z0-9][A-Za-z0-9]*$';
export const OBJECT_FIELD_PATH_PATTERN = '^(?:\\w+[.])*\\w+$';
export const MIME_PDF_PATTERN = 'application/pdf';
export const MIME_IMAGE_PATTERN = '^image/\\w+';
export const CITY_PATTERN = '^.{1,200}$';
export const CITY_MAX_LENGTH = 200;
export const FINANCE_NUMBER_PATTERN = /^\d+$/;

export const PHONE_PATTERNS_BY_COUNTRY_CODE = {
  US: '^\\d{10}$',
  CANADA: '^\\d{10}$',
  JAMAICA: '^\\d{10}$',
  PHILIPPINES: '^\\d{10}$',
  UK: '^\\d{11}$',
  OTHERS: '^\\d{6,15}$',
  DEFAULT: PHONE_PATTERN,
} as const;
